<ion-header>
    <ion-toolbar>
        <ion-title>{{ infringement.infringementType | translate }}</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="close()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <form [formGroup]="form" *ngIf="formActive">
        <ion-list>

            <ion-item>
                <ion-input label="{{ 'Match' | translate }}" label-placement="stacked" value="{{ participantSide1 }} Vs {{ participantSide2 }}" readonly type="text"></ion-input>
            </ion-item>

            <ion-item>
                <ion-input label="{{ 'Score' | translate }}" label-placement="stacked" value="{{ infringement.scoreStringSide1 }}" readonly type="text"></ion-input>
            </ion-item>

            @if (infringement.interruptionReason) {
                <ion-item>
                    <ion-input label="{{ 'Interruption reason' | translate }}" label-placement="stacked" value="{{ infringement.interruptionReason | translate }}" readonly type="text"></ion-input>
                </ion-item>
            }

            @if (infringement.penalty) {
                <ion-item>
                    <ion-input label="{{ 'Code violation type' | translate }}" label-placement="stacked" value="{{ infringement.penalty?.codeViolationType | translate }}" readonly type="text"></ion-input>
                </ion-item>

                <ion-item>
                    <ion-input label="{{ 'Penalty' | translate }}" label-placement="stacked" value="{{ infringement.penalty?.penaltyType | translate }}" readonly type="text"></ion-input>
                </ion-item>
            }

            @if (infringement.interruptionReason !== 'MATCH_SUSPENSION') {
                <ion-item>
                    <ion-input label="{{ 'Participant' | translate }}" label-placement="stacked" value="{{ infringement.sideNumber === 1 ? participantSide1 : participantSide2 }}" readonly type="text"></ion-input>
                </ion-item>
            } @else {
                <ion-item>
                    <ion-input label="{{ 'Duration' | translate }}" label-placement="stacked" value="{{ convertDuration(infringement.duration) }}" readonly type="text"></ion-input>
                </ion-item>
            }

            <ion-item>
                <ion-input label="{{ 'Updated at' | translate }}" label-placement="stacked" value="{{ infringement.updatedAt | date: 'medium' }}" readonly type="text"></ion-input>
            </ion-item>

            <ion-item *ngIf="!isEdit && !isCreate">
                <ion-input label="{{ 'Note' | translate }}" label-placement="stacked" value="{{ infringement.note | translate }}" readonly type="text"></ion-input>

                <ion-button slot="end" (click)="isEdit = true;" fill="clear">
                    <ion-icon slot="icon-only" name="build"></ion-icon>
                </ion-button>
            </ion-item>

            <ion-item *ngIf="isEdit || isCreate">
                <ion-textarea label="{{ 'Note' | translate }}" label-placement="stacked" rows="3" autocorrect autocomplete autocapitalize spellcheck autoGrow formControlName="note" placeholder="Enter reason"></ion-textarea>

                <ion-button *ngIf="!isCreate" slot="end" (click)="isEdit = false" fill="clear" color="dark">
                    <ion-icon slot="icon-only" name="close"></ion-icon>
                </ion-button>
            </ion-item>

        </ion-list>
    </form>

</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button *ngIf="!isCreate && !isEdit" (click)="delete()" expand="block" color="danger">{{ 'Delete' | translate }}
            
        </ion-button>

        <ion-button *ngIf="isCreate || isEdit" (click)="save()" expand="block" color="primary">{{ 'Save' | translate }}
        </ion-button>
    </ion-toolbar>
</ion-footer>